var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDuoWatch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    transform: "rotate(0 0 0)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5032 11.9997C19.5032 16.1438 16.1438 19.5032 11.9997 19.5032C7.85573 19.5032 4.49619 16.1441 4.49609 11.9998C4.49619 7.85441 7.85698 4.49609 11.9997 4.49609C16.0838 4.49609 19.5032 7.91084 19.5032 11.9997ZM12 8.11328C11.5858 8.11328 11.25 8.44907 11.25 8.86328V11.9999C11.25 12.1988 11.329 12.3895 11.4696 12.5302L12.8835 13.9444C13.1763 14.2373 13.6512 14.2374 13.9441 13.9445C14.2371 13.6517 14.2371 13.1768 13.9443 12.8839L12.75 11.6893V8.86328C12.75 8.44907 12.4142 8.11328 12 8.11328Z",
    fill: "currentColor"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.67112 2C8.63867 2 7.73871 2.70267 7.4883 3.70429L7.16328 5.00441C8.53631 4.05333 10.2029 3.49609 11.9996 3.49609C13.7967 3.49609 15.4636 4.05356 16.8368 5.00499L16.5116 3.70429C16.2612 2.70267 15.3612 2 14.3288 2H9.67112Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.16309 18.9948C8.53616 19.9459 10.2028 20.5032 11.9996 20.5032C13.7968 20.5032 15.4637 19.9457 16.837 18.9942L16.5116 20.2956C16.2612 21.2972 15.3612 21.9998 14.3288 21.9998H9.67111C8.63867 21.9998 7.73871 21.2972 7.4883 20.2956L7.16309 18.9948Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuoWatch);
export default __webpack_public_path__ + "static/media/DuoWatch.f7dd4d51387ccf13219dfd658d81ba60.svg";
export { ForwardRef as ReactComponent };